import React, {Component} from 'react';
import Map from '../Map';
import RegionMap from '../RegionMap';
import DataSection from '../DataSection';
import ContactsWrapper from '../ContactsWrapper';

/** removed <ContactsWrapper {...this.props} /> below <DataSection> */

class MainContent extends Component{
    render(){
        let map = !this.props.currentRegion ?  <Map {...this.props} /> : <RegionMap {...this.props} />;
        return(
        <div className="main-content-wrapper">  
            <div className="main-content">
                {map}
                <DataSection {...this.props}/> 
            </div>
        </div>         
        )
    }
}

export default MainContent;


// WEBPACK FOOTER //
// ./src/js/components/layout/MainContent.js